import React from 'react';

import AddButton from '../../shared/AddButton';

const CaseUsageSetRow = (props) => {
  const { code, description, type, outbound, qty, onChange, tenantColor } = props;

  return (
    <div className='case-usage-modal__table-row'>
      <div style={{ flex: 0.2 }}>{code}</div>
      <div style={{ flex: 0.45 }}>{description}</div>
      <div style={{ flex: 0.1 }}>{type}</div>
      <div style={{ flex: 0.1, color: tenantColor }} className='text-center'>{outbound}</div>
      <div
        style={{ flex: 0.15 }}
        className='font-bold d-flex flex-end'
      >
        <AddButton
          variant='remove'
          disabled={qty === 0}
          onClick={() => onChange(qty - 1)}
        />
        <div className='m-l-md m-r-md text-center' style={{ width: 12 }}>{qty}</div>
        <AddButton onClick={() => onChange(qty + 1)} />
      </div>
    </div>
  );
};

export default CaseUsageSetRow;
